var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{staticClass:"sticky top-0 z-50"}),_c('main',{staticClass:"relative"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }